export const hrManageCandidateApi = {
    heading:[
        {
            head:"Candidate Name"
        },
        {
            head:"Mobile Number"
        },
        {
            head:"Email"
        },
        {
            head:"Present Address"
        },
        {
            head:"Permanent Address"
        },
        {
            head:"Role"
        },
        {
            head:"Department"
        },
        {
            head:"Level"
        },
        {
            head:"Salary Expectation"
        },
        {
            head:"Employement Type"
        },
        {
            head:"Experience"
        },
        {
            head:"Action"
        },
    ],
    data:[
        {
            candidateName:"akib",
            mobilenumber:"4654654654",
            email:"abc@gmail.com",
            presentaddress:"indira road, Dhaka",
            permanentaddress:"indira road, Dhaka",
            role:"UI Designer",
            department:"IT",
            level:"Senior",
            salaryExp:"25000-30000",
            employementType:"Permanent",
            experience:"1 Year",
            action:"./assets/images/dashboards/adminDashboard/HR/icons/crossicon.png"
        },
    ]
}